import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as inquiriesService from "../../services/inquiry.services";
import * as templateService from "../../services/inquiryEmailTemplate.service";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const ViewInquiry = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [replySubject, setReplySubject] = useState("");
  const [replyMessage, setReplyMessage] = useState("");
  const [replying, setReplying] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [carouselIndex, setCarouselIndex] = useState(0);

  useEffect(() => {
    templateService.Options({}).then(res => setTemplates(res?.data || []));
  }, []);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_inquiries"), url: "/admin/inquiries/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    inquiriesService
      .Details({ _id: params.id })
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const handleReply = async (e) => {
    e.preventDefault();
    if (!replySubject.trim() || !replyMessage.trim()) return;
    setReplying(true);
    try {
      const res = await inquiriesService.Reply({ _id: params.id, subject: replySubject, message: replyMessage });
      if (res.success) {
        Swal.fire({ icon: "success", text: "Reply sent successfully", ...SWAL_SETTINGS });
        setReplySubject("");
        setReplyMessage("");
        // Refresh to show updated replies
        inquiriesService.Details({ _id: params.id }).then(r => setShowDefault(r?.data || {}));
      } else {
        Swal.fire({ icon: "error", text: res.message || "Failed to send reply", ...SWAL_SETTINGS });
      }
    } catch (err) {
      Swal.fire({ icon: "error", text: "Something went wrong", ...SWAL_SETTINGS });
    }
    setReplying(false);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">VIEW INQUIRY</h6>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">{showdefault.name || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>{showdefault.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_subject")}</th>
                          <td>{showdefault.subject || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_message")}</th>
                          <td>{showdefault.message || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_inquiry_date")}</th>
                          <td>{showdefault.createdAt ? formateDateWithMonth(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td className="text-capitalize">{showdefault.status || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Type</th>
                          <td>
                            {showdefault.inquiry_type === 'early_access' ? (
                              <span className="badge badge-pill badge-warning-light">Early Access</span>
                            ) : (
                              <span className="badge badge-pill badge-secondary-light">Contact</span>
                            )}
                          </td>
                        </tr>
                        {showdefault.inquiry_type === 'early_access' && (
                          <>
                            <tr>
                              <th>Zip Code</th>
                              <td>{showdefault.zip_code || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Travel Distance</th>
                              <td>{showdefault.travel_distance ? `${showdefault.travel_distance} (${showdefault.travel_miles} miles)` : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Referral</th>
                              <td>{showdefault.referral || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Selected Services</th>
                              <td>
                                {showdefault.selected_services && showdefault.selected_services.length > 0 ? (
                                  <ul className="mb-0 ps-3">
                                    {showdefault.selected_services.map((s, i) => (
                                      <li key={i}>
                                        <strong>{s.categoryTitle}</strong>
                                        {s.subCategoryTitle ? ` — ${s.subCategoryTitle}` : ''}
                                      </li>
                                    ))}
                                  </ul>
                                ) : "N/A"}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Conversation Thread — always show */}
                  <div className="col-lg-12 mt-3">
                    <h6 className="main-content-label mb-2">Conversation Thread</h6>
                  <div style={{maxHeight : '400px' , overflow: 'auto'}}>
                    {/* Original inquiry message */}
                    <div className="card mb-2" style={{ background: "#e8f4fd", border: "1px solid #b8daff" }}>
                      <div className="card-body py-2 px-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="badge badge-pill" style={{ background: "#007bff", color: "#fff" }}>User</span>
                          <small className="text-muted">{showdefault.createdAt ? formateDateWithMonth(showdefault.createdAt) : ""}</small>
                        </div>
                        <p className="mb-0 mt-1 fw-bold">{showdefault.subject}</p>
                        <p className="mb-0 mt-1" style={{ whiteSpace: "pre-wrap" }}>{showdefault.message || "N/A"}</p>
                      </div>
                    </div>

                    {showdefault.replies?.map((reply, i) => {
                      const isAdmin = reply.sentBy !== null && reply.sentBy !== undefined;
                      return (
                        <div key={i} className="card mb-2" style={{
                          background: isAdmin ? "#f0fff0" : "#e8f4fd",
                          border: `1px solid ${isAdmin ? "#c3e6cb" : "#b8daff"}`,
                          marginLeft: isAdmin ? "0" : "20px"
                        }}>
                          <div className="card-body py-2 px-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="badge badge-pill" style={{
                                background: isAdmin ? "#28a745" : "#007bff",
                                color: "#fff"
                              }}>
                                {isAdmin ? "Admin" : "User"}
                              </span>
                              <small className="text-muted">{reply.sentAt ? formateDateWithMonth(reply.sentAt) : ""}</small>
                            </div>
                            <p className="mb-0 mt-1 fw-bold">{reply.subject}</p>
                            <p className="mb-0 mt-1" style={{ whiteSpace: "pre-wrap" }}>
                              {reply.message ? reply.message.replace(/\s*On\s+\w+,\s+\w+\s+\d+.*$/s, '').trim() : ''}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  </div>

                  {/* Quick Reply Templates Carousel */}
                  {templates.length > 0 && (
                    <div className="col-lg-12 mt-4">
                      <h6 className="main-content-label mb-2">Quick Reply Templates</h6>
                      <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                          onClick={() => setCarouselIndex(i => Math.max(0, i - 1))}
                          disabled={carouselIndex === 0}>
                          <i className="ri-arrow-left-s-line"></i>
                        </button>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                          <div style={{ display: 'flex', gap: '12px', transition: 'transform 0.3s' }}>
                            {templates.slice(carouselIndex, carouselIndex + 3).map((tpl, i) => (
                              <div key={i} className="card" style={{
                                minWidth: '200px', flex: '1', cursor: 'pointer',
                                border: '1px solid #dee2e6', background: '#f8f9fa'
                              }}
                                onClick={() => { setReplySubject(tpl.subject); setReplyMessage(tpl.body); }}
                              >
                                <div className="card-body py-2 px-3">
                                  <p className="mb-1 fw-bold" style={{ fontSize: '0.85em' }}>{tpl.title}</p>
                                  <p className="mb-0 text-muted" style={{ fontSize: '0.78em' }}>{tpl.subject}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                          onClick={() => setCarouselIndex(i => Math.min(templates.length - 1, i + 1))}
                          disabled={carouselIndex + 3 >= templates.length}>
                          <i className="ri-arrow-right-s-line"></i>
                        </button>
                      </div>
                      <small className="text-muted">Click a template to pre-fill the reply form</small>
                    </div>
                  )}

                  {/* Reply Form */}
                  <div className="col-lg-12 mt-4">
                    <h6 className="main-content-label mb-3">Reply to Inquiry</h6>
                    <form onSubmit={handleReply}>
                      <div className="form-group">
                        <label>Subject</label>
                        <input
                          type="text"
                          className="form-control"
                          value={replySubject}
                          onChange={(e) => setReplySubject(e.target.value)}
                          placeholder="Enter reply subject"
                          required
                        />
                      </div>
                      <div className="form-group mt-2">
                        <label>Message</label>
                        <textarea
                          className="form-control"
                          rows={5}
                          value={replyMessage}
                          onChange={(e) => setReplyMessage(e.target.value)}
                          placeholder="Enter your reply message"
                          required
                        />
                      </div>
                      <button type="submit" className="btn btn-primary mt-2" disabled={replying}>
                        {replying ? "Sending..." : "Send Reply"}
                      </button>
                    </form>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>

            <div className="mt-5 back-button">
              <button className="btn ripple btn-dark" type="button" onClick={() => navigate("/admin/inquiries/list/1")}>
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewInquiry;
